<template>
  <section :id="shopifyData.sectionId" class="the-you-tube" :style="sectionStyles">
    <div class="container">
      <div class="the-you-tube__video youtube-wrapper">
        <!-- Direct YouTube Iframe (shows default thumbnail + play icon) -->
        <iframe
          ref="videoElement"
          :src="youtubeEmbedUrl"
          allow="encrypted-media"
          frameborder="0"
          allowfullscreen
          loading="lazy"
          webkit-playsinline="true"
          playsinline="true"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: { type: Object, required: true },
  },

  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },

  computed: {
    sectionStyles() {
      const deskPadding = this.shopifyData.deskPadding || 35;
      const mobPadding = this.shopifyData.mobPadding || 10;
      return {
        padding: `${this.windowWidth > 768 ? deskPadding : mobPadding}px`,
      };
    },

    youtubeEmbedUrl() {
      const link = this.shopifyData.videolink;
      const match = link.match(/(?:youtube\.com.*v=|youtu\.be\/)([^&]+)/);
      const videoId = match ? match[1] : null;

      return videoId
        ? `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&controls=1&playsinline=1`
        : link;
    },
  },

  mounted() {
    this.updateWidth();
    window.addEventListener('resize', this.updateWidth);
  },

  beforeMount() {
    window.removeEventListener('resize', this.updateWidth);
  },

  methods: {
    updateWidth() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style scoped>
.youtube-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* Aspect ratio 16:9 */
  height: 0;
  overflow: hidden;
}

.youtube-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
